import {toFarsiNumber} from "../cudtom-hooks/en-to-persian";
import {useContext} from "react";
import {MyContext} from "../context/myContext";
import Loading from "./Loading";
import {useSelector} from "react-redux";
import {selectIsPending} from "../features/common-states/commonStatesSlice";
import {selectRequestStyles} from "../features/request/requestSlice";

const UserInformationTable = () => {
    const {headArray, bodyArray, searchedBodyArray} = useContext(MyContext)
    const data = searchedBodyArray?.length > 0 ? searchedBodyArray : bodyArray; //searchedBodyArray comes from UserManagement
    const isPending = useSelector(selectIsPending)
    const statusStyle = useSelector(selectRequestStyles)
    return(
        <div className='table-container'>
            <table className='user-table'>
                <thead>
                <tr>
                    {headArray.map((item, index) => {
                        return <th key={index}>{item}</th>
                    })}
                </tr>
                </thead>
                {isPending ? <tbody><tr><td colSpan='100'><Loading /></td></tr></tbody> :
                    <tbody>
                    {(data?.length === 0 || data[0] === 'موردی یافت نشد') ? <tr><td className='empty-table' colSpan='100%'>موردی یافت نشد</td></tr> :
                        data?.map((item, index) => {
                            return(
                                <tr key={index}>
                                    {item.map((entry, index1) => {
                                        return <td key={index1} className='table-entry' style={index1 === 12 ? statusStyle[index] : {}}>{entry}</td>
                                    })}
                                    <td>{toFarsiNumber(index + 1)}</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                }
            </table>
        </div>
    )
}

export default UserInformationTable